import { mainActionTypes } from './main.types';

// FETCH DIAGRAMS LIST
// --------------------------------------------------------------
export const fetchDiagramsList = () => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAMS_LIST_REQUEST,
})
export const fetchDiagramsListSuccess = (data) => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAMS_LIST_SUCCESS,
    payload: { data },
})
export const fetchDiagramsListFailure = error => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAMS_LIST_FAILURE,
    payload: error,
})

// FETCH TEMPLATES LIST
// --------------------------------------------------------------
export const fetchTemplatesList = () => ({
    type: mainActionTypes.MAIN_FETCH_TEMPLATES_LIST_REQUEST,
})
export const fetchTemplatesListSuccess = (data) => ({
    type: mainActionTypes.MAIN_FETCH_TEMPLATES_LIST_SUCCESS,
    payload: { data },
})
export const fetchTemplatesListFailure = error => ({
    type: mainActionTypes.MAIN_FETCH_TEMPLATES_LIST_FAILURE,
    payload: error,
})

// RENAME DIAGRAM
// --------------------------------------------------------------
export const toggleModalDiagramRename = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_RENAME,
    payload: { id },
});
export const diagramRename = (id, body) => ({
    type: mainActionTypes.MAIN_DIAGRAM_RENAME_REQUEST,
    payload: { id, body },
});
export const diagramRenameSuccess = (id, data) => ({
    type: mainActionTypes.MAIN_DIAGRAM_RENAME_SUCCESS,
    payload: { id, data },
});
export const diagramRenameFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_RENAME_FAILURE,
    payload: error,
});

// CLONE DIAGRAM
// --------------------------------------------------------------
export const toggleModalDiagramClone = (page, id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_CLONE,
    payload: { id, page },
});
export const diagramClone = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_CLONE_REQUEST,
    payload: { id, name },
});
export const diagramCloneSuccess = () => ({
    type: mainActionTypes.MAIN_DIAGRAM_CLONE_SUCCESS,
});
export const diagramCloneFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_CLONE_FAILURE,
    payload: error,
});

// SOFT DELETE DIAGRAM (ARCHIVE)
// --------------------------------------------------------------
export const toggleModalDiagramSoftDelete = (page, id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_SOFT_DELETE,
    payload: { id, page },
});
export const diagramSoftDelete = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_SOFT_DELETE_REQUEST,
    payload: { id, name },
});
export const diagramSoftDeleteSuccess = (id) => ({
    type: mainActionTypes.MAIN_DIAGRAM_SOFT_DELETE_SUCCESS,
    payload: { id },
});
export const diagramSoftDeleteFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_SOFT_DELETE_FAILURE,
    payload: error,
});
export const clearDiagramErrors = (id) => ({
    type: mainActionTypes.MAIN_CLEAR_DIAGRAM_ERRORS,
});

// DELETE DIAGRAM
// --------------------------------------------------------------
export const toggleModalDiagramDelete = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_DELETE,
    payload: { id },
});
export const diagramDelete = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_DELETE_REQUEST,
    payload: { id, name },
});
export const diagramDeleteSuccess = (id) => ({
    type: mainActionTypes.MAIN_DIAGRAM_DELETE_SUCCESS,
    payload: { id },
});
export const diagramDeleteFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_DELETE_FAILURE,
    payload: error,
});

// RESTORE DIAGRAM
// --------------------------------------------------------------
export const toggleModalDiagramRestore = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_RESTORE,
    payload: { id },
});
export const diagramRestore = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_RESTORE_REQUEST,
    payload: { id, name },
});
export const diagramRestoreSuccess = (id) => ({
    type: mainActionTypes.MAIN_DIAGRAM_RESTORE_SUCCESS,
    payload: { id },
});
export const diagramRestoreFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_RESTORE_FAILURE,
    payload: error,
});

// SHARE DIAGRAM
// --------------------------------------------------------------
export const toggleModalDiagramShare = (page, id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_SHARE,
    payload: { id, page },
});
export const diagramShare = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_SHARE_REQUEST,
    payload: { id, name },
});
export const diagramShareSuccess = (id, name) => ({
    type: mainActionTypes.MAIN_DIAGRAM_SHARE_SUCCESS,
    payload: { id, name },
});
export const diagramShareFailure = error => ({
    type: mainActionTypes.MAIN_DIAGRAM_SHARE_FAILURE,
    payload: error,
});

// CLONE TEMPLATE
// --------------------------------------------------------------
export const toggleModalTemplateClone = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_TEMPLATE_CLONE,
    payload: { id },
});
export const templateClone = (id, name) => ({
    type: mainActionTypes.MAIN_TEMPLATE_CLONE_REQUEST,
    payload: { id, name },
});
export const templateCloneSuccess = () => ({
    type: mainActionTypes.MAIN_TEMPLATE_CLONE_SUCCESS,
});
export const templateCloneFailure = error => ({
    type: mainActionTypes.MAIN_TEMPLATE_CLONE_FAILURE,
    payload: error,
});

// SIDEBAR
// --------------------------------------------------------------
export const toggleSidebarCollapse = (isSidebarCollapsed) => ({
    type: mainActionTypes.TOGGLE_SIDEBAR_COLLAPSE,
    payload: { isSidebarCollapsed },
});
export const toggleSidebarProfileMenu = () => ({
    type: mainActionTypes.TOGGLE_SIDEBAR_PROFILE_MENU,
});

// PRICING PLAN
// --------------------------------------------------------------
export const enablePricingPlanLimit = () => ({
    type: mainActionTypes.ENABLE_MODAL_PRICING_PLAN_LIMIT,
});
export const disablePricingPlanLimit = () => ({
    type: mainActionTypes.DISABLE_MODAL_PRICING_PLAN_LIMIT,
});

export const togglePricingPlanUpgrade = (page) => ({
    type: mainActionTypes.TOGGLE_MODAL_PRICING_PLAN_UPGRADE,
    payload: { page },
});


// DIAGRAM CREATE
// --------------------------------------------------------------
export const toggleDiagramCreate = (page) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_CREATE,
    payload: { page },
});
export const toggleDiagramCreateNew = (page) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_CREATE_NEW,
    payload: { page },
});

// DIAGRAM IMPORT SQL
// --------------------------------------------------------------
export const toggleDiagramImportSql = (type) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_IMPORT_SQL,
    payload: { type },
});

// DIAGRAM / TEMPLATE DETAILS
// --------------------------------------------------------------
export const toggleDiagramDetails = (page, id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_DETAILS,
    payload: { page, id },
});
export const toggleTemplateDetails = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_TEMPLATE_DETAILS,
    payload: { id },
});

// SUPPORT
// --------------------------------------------------------------
export const toggleSupport = (type, page) => ({
    type: mainActionTypes.TOGGLE_MODAL_SUPPORT,
    payload: { type, page },
});
export const sendFeedback = (data) => ({
    type: mainActionTypes.SUPPORT_REQ_REQUEST,
    payload: { data },
});
export const sendFeedbackSuccess = (data) => ({
    type: mainActionTypes.SUPPORT_REQ_SUCCESS,
    payload: { data },
});
export const sendFeedbackFailure = error => ({
    type: mainActionTypes.SUPPORT_REQ_FAILURE,
    payload: error,
});

export const clearFeedbackSentStatus = (id) => ({
    type: mainActionTypes.MAIN_CLEAR_FEEDBACK_SENT_STATUS,
});

// FEEDBACK THANKS
export const toggleModalFeedbackThanks = (type, page) => ({
    type: mainActionTypes.TOGGLE_MODAL_FEEDBACK_THANKS,
    payload: { type, page },
});


// INVITE PEOPLE
// --------------------------------------------------------------
export const toggleInvitePeople = () => ({
    type: mainActionTypes.TOGGLE_MODAL_INVITE_PEOPLE,
});
export const invitePeople = (email) => ({
    type: mainActionTypes.INVITE_PEOPLE_REQUEST,
    payload: { email },
});
export const invitePeopleSuccess = (data) => ({
    type: mainActionTypes.INVITE_PEOPLE_SUCCESS,
    payload: { data },
});
export const invitePeopleFailure = error => ({
    type: mainActionTypes.INVITE_PEOPLE_FAILURE,
    payload: error,
});

export const clearInviteSentStatus = (id) => ({
    type: mainActionTypes.MAIN_CLEAR_INVITE_SENT_STATUS,
});

export const mainCanvasStarted = () => ({
    type: mainActionTypes.MAIN_CANVAS_STARTED,
})




// MAIN FETCH DIAGRAM
// --------------------------------------------------------------
export const fetchDiagramMain = () => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_REQUEST,
})
export const fetchDiagramSuccessMain = (data) => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_SUCCESS,
    payload: { data },
})
export const fetchDiagramFailureMain = error => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_FAILURE,
    payload: error,
})





// // LOAD NEW PROJECT
// // --------------------------------------------------------------
// export const loadNewProject = () => ({
//     type: mainActionTypes.LOAD_NEW_PROJECT,
// });

// // LOAD SAMPLE PROJECT DETAILS
// // --------------------------------------------------------------
// export const loadSampleProjectDetails = () => ({
//     type: mainActionTypes.LOAD_SAMPLE_PROJECT_DETAILS,
// });

// MODAL LANGUAGES
// --------------------------------------------------------------
export const toggleModalLanguages = () => ({
    type: mainActionTypes.TOGGLE_MODAL_LANGUAGES,
});


// MODAL WORKSPACE
// --------------------------------------------------------------
export const toggleModalWorkspaceCreate = () => ({
    type: mainActionTypes.TOGGLE_MODAL_WORKSPACE_CREATE,
});


export const toggleSidebarWorkspaceMenu = () => ({
    type: mainActionTypes.TOGGLE_SIDEBAR_WORKSPACE_MENU,
});
